import { Box, BoxProps, InputAdornment, TextField, Typography } from "@mui/material"
import { DatePicker, jaJP } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Calendar } from "@mui/x-date-pickers/internals/components/icons"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider"
import { Dayjs } from "dayjs"
import "dayjs/locale/ja"
import React from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"

type Props = {
  sx?: BoxProps
  name?: string
  placeholder?: string
  required?: boolean
  readOnly?: boolean
  disabled?: boolean
  date: Dayjs | null
  handleDate: any
  validationMessage?: string
  description?: string
  inputStyle?: BoxProps
  checkValidation?: any
}

const InputDateField = ({
  sx,
  name,
  required,
  readOnly,
  disabled,
  date,
  handleDate,
  validationMessage,
  description,
  inputStyle,
  checkValidation,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "base" })

  const isMobile = useMediaQuery({ query: "(max-width: 680px)" })

  const style = sx || {}

  const customStyle = {
    "& .MuiInput-input": {
      fontSize: "1rem",
      borderWidth: "1px",
    },
  }

  return (
    <Box
      sx={{
        ...style,
      }}
    >
      {name && (
        <Box display="flex">
          <Typography className="name">{name}</Typography>
          {required && (
            <Box className="required-container">
              <Typography className="required">{t("required")}</Typography>
            </Box>
          )}
        </Box>
      )}
      <Box display="flex" sx={{ mt: name ? "10px" : "0px" }}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="ja"
          localeText={jaJP.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <DatePicker
            disabled={disabled}
            inputFormat="YYYY/MM/DD"
            readOnly={readOnly}
            value={date}
            DialogProps={{
              sx: { svg: { color: "#222222" }, span: { color: "#222222" } },
            }}
            PopperProps={{
              sx: { svg: { color: "#222222" }, span: { color: "#222222" } },
            }}
            onChange={(newValue) => {
              handleDate(newValue)
              if (checkValidation) {
                checkValidation()
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Calendar />
                </InputAdornment>
              ),
            }}
            renderInput={(params) => (
              <TextField
                variant="outlined"
                {...params}
                sx={{
                  ...customStyle,
                  ...inputStyle,
                  "& .MuiOutlinedInput-root": {
                    height: inputStyle ? (inputStyle.height ? inputStyle.height : "56px") : "56px",
                  },
                  ...(readOnly ? { backgroundColor: "#EAF1FB" } : {}),
                  "& .MuiInputBase-input": {
                    // "::placeholder": {  },
                  },
                  ...(isMobile ? { width: "100%" } : {}),
                }}
                error={false}
              />
            )}
          />
        </LocalizationProvider>
      </Box>
      {validationMessage ? (
        <Box sx={{ height: "20px", pt: "5px" }}>
          <Typography className="description error">{validationMessage}</Typography>
        </Box>
      ) : description ? (
        <Box sx={{ height: "20px", pt: "5px" }}>
          <Typography className="description">{description}</Typography>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  )
}

export default InputDateField
